// customerCacheService.js
import localforage from 'localforage';
import axios from 'axios';

const customerStore = localforage.createInstance({
  name: 'dukakit_pos',
  storeName: 'customers'
});

const CACHE_KEY = 'customers';
const TIMESTAMP_KEY = 'customers_last_updated';
const ONE_HOUR = 60 * 60 * 1000;

export default {
  async getCustomers(searchTerm = '', force = false) {
    const isSearching = String(searchTerm).trim().length > 0;


    if (isSearching) {
      console.log(`🔎 Searching customers: "${searchTerm}" (bypassing cache)`);
      const response = await axios.get(`/api/allcustomers?perPage=10&search=${searchTerm}`);
      return response.data.data;
    }

    const now = Date.now();
    const lastUpdated = await customerStore.getItem(TIMESTAMP_KEY);
    const isCacheFresh = lastUpdated && (now - lastUpdated < ONE_HOUR);

    if (!force && isCacheFresh) {
      console.log('📦 Using cached customers (fresh)');
      const cached = await customerStore.getItem(CACHE_KEY);
      if (cached) return cached;
    }

    console.log(force ? '🔄 Forcing fresh customer fetch from backend' : '⏳ Customer cache stale or missing, fetching from backend');

    try {
      const response = await axios.get('/api/allcustomers?perPage=1000'); // large prefetch
      const customers = response.data.data;

      await customerStore.setItem(CACHE_KEY, customers);
      await customerStore.setItem(TIMESTAMP_KEY, now);

      console.log('✅ Customers updated from backend at', new Date().toLocaleString());
      return customers;
    } catch (e) {
      console.warn('⚠️ Backend fetch failed, falling back to cached customers');
      const fallback = await customerStore.getItem(CACHE_KEY);
      if (fallback) return fallback;
      throw new Error('❌ Unable to fetch customers and no cached data available.');
    }
  },

  async clearCache() {
    await customerStore.removeItem(CACHE_KEY);
    await customerStore.removeItem(TIMESTAMP_KEY);
    console.log('🧹 Customer cache cleared');
  }
};
